import { useQuery } from '@tanstack/react-query'
import { getOrgUsers } from '~/services/organizationService'
import { QueryKeys } from '~/services/queryClient'
import { ResOrgUser, User } from '~/types/ResponseType'

export function useOrgUsers() {
  const { data: users } = useQuery({
    queryKey: QueryKeys.OrgUsers,
    queryFn: getOrgUsers,
    initialData: [] as ResOrgUser[]
  })
  return users as ResOrgUser[]
}
